module.exports = __webpack_public_path__ + "img/3.53abd714.jpg";